module.exports = __webpack_public_path__ + "static/media/mobile_dev.10694df8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile_dev.jpg
// module id = 377
// module chunks = 0